import React, {useState, useEffect} from 'react';
import {API_ENDPOINTS} from "../../../apiConfig";
import API from "../../../utils/API";
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Forms from "../../../components/Forms";
import RepairCatalogModal from "../../../components/RepairCatalogModal";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import {useModal} from "../../../contexts/ModalContext";
import AdminDataView from "../../../components/AdminDataView";

import "./RepairCatalog.css";

const RepairCatalog = () => {
    const [repairCatalogItems, setRepairCatalogItems] = useState([]);
    const {t} = useTranslation();
    const [error, setError] = useState();
    const {openModal, confirm} = useModal();

    const fetchRepairCatalogItems = async () => {
        const response = await API.get(API_ENDPOINTS.repairCatalog.list);
        setRepairCatalogItems(response.data);
    };


    useEffect(() => {
        fetchRepairCatalogItems();
    }, []);

    const columns = [
        {
            key: 'name',
            name: t('name'),
            minWidth: 300,
            renderCell: ({row}) => <label className="label">{row.name}</label>
        },
        {key: 'description', name: t('description')},
        {key: 'discount', name: t('discount'), minWidth: 80},
        {
            key: 'timeRequirement',
            name: `${t('timeRequirement')} (min)`,
            minWidth: 120,
            renderCell: ({row}) => row.timeRequirement ?? '-'
        },
        {
            key: 'createdBy',
            name: t('createdBy'),
            minWidth: 150,
            renderCell: ({row}) => `${row.createdBy.name} ${row.createdBy.surname}`
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            minWidth: 150,
            renderCell: ({row}) => moment(row.createdAt).format('DD.MM.YYYY HH:mm')
        },
        {
            key: 'actions',
            name: 'Akce',
            width: 110,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit položku opravy" onClick={() => openRepairCatalogModal(row)}/>
                    <DeleteIconButton title="Smazat položku opravy" onClick={() => confirmDeleteRepairItem(row)}/>
                </div>
            )
        }
    ].map(column => ({...column, resizable: true}));

    const confirmDeleteRepairItem = async (repairCatalogItem) => {
        const result = await confirm(`Opravdu chcete smazat opravu "${repairCatalogItem.name}"?`);
        if (result === true) {
            try {
                await API.delete(API_ENDPOINTS.repairCatalog.delete(repairCatalogItem._id));
                setRepairCatalogItems(repairCatalogItems.filter(r => r._id !== repairCatalogItem._id));
            } catch (error) {
                setError(error);
                console.error("Failed to delete repair:", error);
            }
        }
    };

    const openRepairCatalogModal = (item) => {
        openModal(RepairCatalogModal, {catalogRepair: item, onRepairUpdate: fetchRepairCatalogItems}, {title: 'test'});
    }

    return (
        <div className="RepairCatalog">
            <Forms.Button label={t('addRepair')} onClick={() => openRepairCatalogModal()} className="mb-8"/>
            <AdminDataView section="repair-catalog" rows={repairCatalogItems} columns={columns}/>
        </div>
    );
};

export default RepairCatalog;
